import { render } from "./ReviewItem.vue?vue&type=template&id=59c8d418&scoped=true"
import script from "./ReviewItem.vue?vue&type=script&lang=js"
export * from "./ReviewItem.vue?vue&type=script&lang=js"

import "./ReviewItem.vue?vue&type=style&index=0&id=59c8d418&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c8d418"]])

export default __exports__